import { getApiAxiosInstance } from '../utils/network';

// UT_API answers every business outcome as 200 `{ outcome, retryAfterSeconds }`; only transport
// failures (401, 422, 429, 5xx, network) reject, and callers decide what a rejection means.
export const sendVerificationCode = async (trigger) => {
    const response = await getApiAxiosInstance().post('v1/account/emailverification/send', { trigger });
    return response?.data;
};

export const verifyEmailCode = async (code) => {
    const response = await getApiAxiosInstance().post('v1/account/emailverification/verify', { code });
    return response?.data;
};
